import React, { useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import CardSlideOne from "../../../assets/images/card-slider/webp/card_slider_home_one.webp";
import CardSlideTwo from "../../../assets/images/card-slider/webp/card_slider_home_two.webp";
import CardSlideThree from "../../../assets/images/card-slider/webp/card_slider_home_three.webp";
import CardSlideFour from "../../../assets/images/card-slider/webp/card_slider_home_four.webp";

import CardSlideFive from "../../../assets/images/card-slider/webp/card_slider_home_five.webp";
import CardSlideSix from "../../../assets/images/card-slider/webp/card_slider_home_six.webp";
import CardSlideSeven from "../../../assets/images/card-slider/webp/card_slider_home_seven.webp";
import CardSlideEight from "../../../assets/images/card-slider/webp/card_slider_home_eight.webp";
import CardSlideNine from "../../../assets/images/card-slider/webp/card_slider_home_nine.webp";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards, Pagination } from "swiper/modules";
// import LIGHTBOX
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";
export default function CardSwiper() {
  const [isOpen, setIsOpen] = useState(false);

  const finalSpiritualImages = [
    {
      src: CardSlideFour,
      alt: "spiritual-img-four",
    },
    {
      src: CardSlideNine,
      alt: "spiritual-img-nine",
    },
    {
      src: CardSlideOne,
      alt: "spiritual-img-one",
    },
    {
      src: CardSlideTwo,
      alt: "spiritual-img-two",
    },

    {
      src: CardSlideFive,
      alt: "spiritual-img-five",
    },
    {
      src: CardSlideSix,
      alt: "spiritual-img-six",
    },
    {
      src: CardSlideSeven,
      alt: "spiritual-img-seven",
    },
    {
      src: CardSlideEight,
      alt: "spiritual-img-eight",
    },
  ];
  return (
    <>
      <Swiper
        effect={"cards"}
        grabCursor={true}
        pagination={{ clickable: true }}
        modules={[EffectCards, Pagination]}
        className="mySwiper"
      >
        {finalSpiritualImages.map((obj, index) => {
          return (
            <SwiperSlide key={index}>
              <img
                className="w-100 h-100 object-fit-cover"
                src={obj.src}
                alt={obj.alt}
                onClick={() => {
                  setIsOpen(true);
                }}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <SlideshowLightbox
        images={finalSpiritualImages}
        showThumbnails={true}
        open={isOpen}
        lightboxIdentifier="lbox1"
        onClose={() => {
          setIsOpen(false);
        }}
      ></SlideshowLightbox>
    </>
  );
}
